/*
 * Envio de imagem. Fica separado do apiRequest porque multipart nao leva
 * Content-Type definido por nos — o navegador precisa montar o boundary.
 */
import { ApiRequestError, UNAUTHENTICATED_EVENT } from './api';
import type { MediaUploadDto } from './types';

function lerCookie(nome: string): string | null {
  const achado = document.cookie.match(new RegExp(`(?:^|; )${nome}=([^;]*)`));
  return achado?.[1] ? decodeURIComponent(achado[1]) : null;
}

export function enviarImagem(arquivo: File): Promise<MediaUploadDto> {
  return enviarArquivo<MediaUploadDto>('/api/admin/media', arquivo);
}

/** Anexa um print a uma mensagem de chamado que o proprio usuario acabou de enviar. */
export function anexarAoChamado(
  ticketId: number,
  messageId: number,
  arquivo: File,
): Promise<{ id: number; fileName: string }> {
  return enviarArquivo(`/api/admin/tickets/${ticketId}/messages/${messageId}/attachments`, arquivo);
}

async function enviarArquivo<T>(url: string, arquivo: File): Promise<T> {
  const corpo = new FormData();
  corpo.append('file', arquivo);

  const csrf = lerCookie('hs_csrf');

  const resposta = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    // Sem Content-Type: o navegador define com o boundary correto.
    headers: csrf ? { 'X-CSRF-Token': csrf } : {},
    body: corpo,
  });

  const dados = (await resposta.json().catch(() => null)) as
    | { data?: T; error?: { code: string; message: string } }
    | null;

  if (!resposta.ok) {
    if (resposta.status === 401) window.dispatchEvent(new CustomEvent(UNAUTHENTICATED_EVENT));
    throw new ApiRequestError(
      (dados?.error?.code as never) ?? 'INTERNAL_ERROR',
      dados?.error?.message ?? 'Falha ao enviar a imagem',
      resposta.status,
    );
  }

  return dados?.data as T;
}
